import React, { useEffect, useState } from "react";
import { checkedState, unCheckedState, UpdateAccountEmailNotificationPreferenceAsync, getvueAccountEMailNotificationPreferencessAsync } from "./emailNotificationPreferenceSlice";
import { WindowDash } from "react-bootstrap-icons";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { KTIcon } from '../../../_metronic/helpers';
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { getValueFromResource } from "../../../common/timeLiveFunction";

const itemClass = 'ms-1 ms-lg-0';

export const EmailNotificationPreferenceItem = (props: any) => {
    const { EmailNotificationPreferenceList } = props;
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { isReload } = useAppSelector((state) => state.emailNotificationPreference);
    const { manageTerminologyList } = useAppSelector((state) => state.globalState);
    const handleCheckboxChange = (e: any, AccountEMailNotificationPreferenceId: any, FieldName: string) => {
        if (e.target.checked) {
            dispatch(checkedState({ AccountEMailNotificationPreferenceId, FieldName }))
        } else {
            dispatch(unCheckedState({ AccountEMailNotificationPreferenceId, FieldName }))
        }
    };

    return (
        <>
        
            <table className="table table-row-bordered  align-middle " >
                <thead>
                    <tr className="thHeading align-middle ">

                        <th className='w-44'>
                            {/* {t('EMail Notification')} */}
                            {getValueFromResource('EMail Notification',dispatch, t)}

                            </th>
                        <th className='w-7 text-center'>
                            {/* {t('Enable / Disable')} */}
                            {getValueFromResource('Enable / Disable',dispatch, t)}

                            </th>
                        <th className='w-7 text-center'>
                            {/* {t('Mon')} */}
                            {getValueFromResource('Mon',dispatch, t)}
                            </th>
                        <th className='w-7 text-center'>
                            {/* {t('Tue')} */}
                            {getValueFromResource('Tue',dispatch, t)}

                            </th>
                        <th className='w-7 text-center'>
                            {/* {t('Wed')} */}
                            {getValueFromResource('Wed',dispatch, t)}
                            </th>
                        <th className='w-7 text-center'>
                            {/* {t('Thu')} */}
                            {getValueFromResource('Thu',dispatch, t)}
                            </th>
                        <th className='w-7 text-center'>
                            {/* {t('Fri')} */}
                            {getValueFromResource('Fri',dispatch, t)}
                            </th>
                        <th className='w-7 text-center'>
                            {/* {t('Sat')} */}
                            {getValueFromResource('Sat',dispatch, t)}

                            </th>
                        <th className='w-7 text-center'>
                            {/* {t('Sun')} */}
                            {getValueFromResource('Sun',dispatch, t)}

                            </th>
                    </tr>
                </thead>
                <tbody>
                    {EmailNotificationPreferenceList.length > 0 && EmailNotificationPreferenceList.map((EmailNotificationPreferencesDetails: any, i: any) => (
                        <tr key={i}>
                            <td>{EmailNotificationPreferencesDetails.SystemEMailNotification}</td>
                            <td className='text-center'>
                                <div className="form-check form-switch form-check-custom justify-content-center">
                                    <input
                                        type="checkbox"
                                        className="form-check-input custom-padding-center h-15px w-30px text-center"
                                        id="IsDisabled"
                                        checked={EmailNotificationPreferencesDetails.Enabled == true ? true : false}
                                        onChange={e => handleCheckboxChange(e, EmailNotificationPreferencesDetails.AccountEMailNotificationPreferenceId, 'Enabled')}
                                    />
                                </div>
                            </td>
                            <td>
                                {EmailNotificationPreferencesDetails.IsWeekDayAllow == true ? (
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox  justify-content-center'>
                                        <input type="checkbox" className="form-check-input widget-9-check"
                                            checked={EmailNotificationPreferencesDetails.Monday == true ? true : false}
                                            onChange={e => handleCheckboxChange(e, EmailNotificationPreferencesDetails.AccountEMailNotificationPreferenceId, "Monday")}
                                        />
                                    </div>
                                ) : null}
                            </td>
                            <td>
                                {EmailNotificationPreferencesDetails.IsWeekDayAllow == true ? (
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox  justify-content-center'>
                                        <input type="checkbox" className="form-check-input widget-9-check"
                                            checked={EmailNotificationPreferencesDetails.Tuesday == true ? true : false}
                                            onChange={e => handleCheckboxChange(e, EmailNotificationPreferencesDetails.AccountEMailNotificationPreferenceId, "Tuesday")}
                                        />
                                    </div>
                                ) : null}
                            </td>
                            <td>
                                {EmailNotificationPreferencesDetails.IsWeekDayAllow == true ? (
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox justify-content-center'>
                                        <input type="checkbox" className="form-check-input widget-9-check"
                                            checked={EmailNotificationPreferencesDetails.Wednesday == true ? true : false}
                                            onChange={e => handleCheckboxChange(e, EmailNotificationPreferencesDetails.AccountEMailNotificationPreferenceId, "Wednesday")}
                                        />
                                    </div>
                                ) : null}
                            </td>
                            <td>
                                {EmailNotificationPreferencesDetails.IsWeekDayAllow == true ? (
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox justify-content-center'>
                                        <input type="checkbox" className="form-check-input widget-9-check"
                                            checked={EmailNotificationPreferencesDetails.Thursday == true ? true : false}
                                            onChange={e => handleCheckboxChange(e, EmailNotificationPreferencesDetails.AccountEMailNotificationPreferenceId, "Thursday")}
                                        />
                                    </div>
                                ) : null}
                            </td>
                            <td>
                                {EmailNotificationPreferencesDetails.IsWeekDayAllow == true ? (
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox justify-content-center'>
                                        <input type="checkbox" className="form-check-input widget-9-check"
                                            checked={EmailNotificationPreferencesDetails.Friday == true ? true : false}
                                            onChange={e => handleCheckboxChange(e, EmailNotificationPreferencesDetails.AccountEMailNotificationPreferenceId, "Friday")}
                                        />
                                    </div>
                                ) : null}
                            </td>
                            <td>
                                {EmailNotificationPreferencesDetails.IsWeekDayAllow == true ? (
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox justify-content-center'>
                                        <input type="checkbox" className="form-check-input widget-9-check"
                                            checked={EmailNotificationPreferencesDetails.Saturday == true ? true : false}
                                            onChange={e => handleCheckboxChange(e, EmailNotificationPreferencesDetails.AccountEMailNotificationPreferenceId, "Saturday")}
                                        />
                                    </div>
                                ) : null}
                            </td>
                            <td>
                                {EmailNotificationPreferencesDetails.IsWeekDayAllow == true ? (
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox justify-content-center'>
                                        <input type="checkbox" className="form-check-input widget-9-check"
                                            checked={EmailNotificationPreferencesDetails.Sunday == true ? true : false}
                                            onChange={e => handleCheckboxChange(e, EmailNotificationPreferencesDetails.AccountEMailNotificationPreferenceId, "Sunday")}
                                        />
                                    </div>
                                ) : null}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {EmailNotificationPreferenceList.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}

                                            {getValueFromResource('No Record Found',dispatch, t)}

                                            </p>
                                    </div>
                                }

        </>
    )
}